import React, { useState } from 'react';
import { TextField } from '@mui/material';
import _ from 'lodash';
export const SocialSecurityField = ({ fieldConfig }) => {
  const [value, setValue] = useState(undefined);

  return (
    <TextField
      fullWidth={fieldConfig.fullWidth}
      disabled={fieldConfig.disabled}
      variant={fieldConfig.variant}
      label={_.get(fieldConfig, 'displayLabel.en', '')}
      helperText={_.get(fieldConfig, 'errorMessage.en', '')}
      required={fieldConfig.required}
      value={value}
      error={false}
      style={{ pointerEvents: 'none' }}
    />
  );
};
